import {
  FETCH_ALL_PROMOCODE_FAILURE,
  FETCH_ALL_PROMOCODE_REQUEST,
  FETCH_ALL_PROMOCODE_SUCCESS,
  VIEW_PROMOCODE_REQUEST,
  VIEW_PROMOCODE_SUCCESS,
  VIEW_PROMOCODE_FAILURE,
  UPDATE_PROMOCODE_REQUEST,
  UPDATE_PROMOCODE_SUCCESS,
  UPDATE_PROMOCODE_FAILURE,
  DELETE_PROMOCODE_REQUEST,
  DELETE_PROMOCODE_SUCCESS,
  DELETE_PROMOCODE_FAILURE,
  CREATE_PROMOCODE_REQUEST,
  CREATE_PROMOCODE_SUCCESS,
  CREATE_PROMOCODE_FAILURE,
  APPROVAL_PROMOCODE_REQUEST,
  APPROVAL_PROMOCODE_SUCCESS,
  APPROVAL_PROMOCODE_FAILURE,
  RESET_FETCH_ALL_PROMOCODE,
  RESET_CREATE_PROMOCODE,
  RESET_VIEW_PROMOCODE,
  RESET_UPDATE_PROMOCODE,
  RESET_DELETE_PROMOCODE,
  RESET_APPROVAL_PROMOCODE,
  VALIDATE_PROMOCODE_REQUEST,
  VALIDATE_PROMOCODE_SUCCESS,
  VALIDATE_PROMOCODE_FAILURE,
  RESET_VALIDATE_PROMOCODE,
} from "./PromoCodeType";

const initialState = {
  promoCodeDetails: {
    data: [],
    totalRecords: 0,
    totalPages: 0,
    currentPage: 1,
    loading: false,
    error: null,
    success: null,
  },
  promoCode: {
    data: null,
    loading: false,
    error: null,
    success: null,
  },
  viewPromoCode:{
    data:null,
    loading:false,
    error:null,
    success:null
  },
  updatePromoCode:{
    data:null,
    loading:false,
    error:null,
    success:null
  },
  deletePromoCode:{
    data:null,
    loading:false,
    error:null,
    success:null
  },
  approvalPromoCode:{
    data:null,
    loading:false,
    error:null,
    success:null
  },
  promoCodeValidation:{
    data:null,
    loading:false,
    error:null,
    success:null
  }
};

const promoCodeReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    // ========================
    // FETCH ALL PROMOCODES
    // ========================
    case FETCH_ALL_PROMOCODE_REQUEST:
      return {
        ...state,
        promoCodeDetails: {
          ...state.promoCodeDetails,
          loading: true,
          data: [],
          error: null,
          success: null,
        },
      };

    case FETCH_ALL_PROMOCODE_SUCCESS:
      return {
        ...state,
        promoCodeDetails: {
          ...state.promoCodeDetails,
          data: payload.data || [],
          totalRecords: payload.totalRecords || 0,
          totalPages: payload.totalPages || 0,
          currentPage: payload.currentPage || 1,
          error: null,
          success: payload.message || "Fetched successfully",
          loading: false,
        },
      };

    case FETCH_ALL_PROMOCODE_FAILURE:
      return {
        ...state,
        promoCodeDetails: {
          ...state.promoCodeDetails,
          data: [],
          error: payload.message || "Failed to fetch promo codes",
          success: null,
          loading: false,
        },
      };
    case RESET_FETCH_ALL_PROMOCODE:
      return {
        ...state,
        promoCodeDetails: {
          ...state.promoCodeDetails,
          data: [],
          error: null,
          success: null,
          loading: false,
        },
      };
    // ========================
    // CREATE PROMOCODE
    // ========================
    case CREATE_PROMOCODE_REQUEST:
      return {
        ...state,
        promoCode: {
          ...state.promoCode,
          loading: true,
          data: null,
          error: null,
          success: null,
        },
      };

    case CREATE_PROMOCODE_SUCCESS:
      return {
        ...state,
        promoCode: {
          ...state.promoCode,
          data: payload.data,
          error: null,
          success: payload.message || "Create success",
          loading: false,
        },
      };

    case CREATE_PROMOCODE_FAILURE:
      return {
        ...state,
        promoCode: {
          ...state.promoCode,
          data: null,
          error: payload.message || "Failed to Create promo code",
          success: null,
          loading: false,
        },
      };
    case RESET_CREATE_PROMOCODE:
      return {
        ...state,
        promoCode: {
          ...state.promoCode,
          data: null,
          error: null,
          success: null,
          loading: false,
        },
      };

    // ========================
    // VIEW PROMOCODE
    // ========================
    case VIEW_PROMOCODE_REQUEST:
      return {
        ...state,
        viewPromoCode: {
          ...state.viewPromoCode,
          loading: true,
          data: null,
          error: null,
          success: null,
        },
      };

    case VIEW_PROMOCODE_SUCCESS:
      return {
        ...state,
        viewPromoCode: {
          ...state.viewPromoCode,
          data: payload.data,
          error: null,
          success: payload.message || "View success",
          loading: false,
        },
      };

    case VIEW_PROMOCODE_FAILURE:
      return {
        ...state,
        viewPromoCode: {
          ...state.viewPromoCode,
          data: null,
          error: payload.message || "Failed to view promo code",
          success: null,
          loading: false,
        },
      };
    case RESET_VIEW_PROMOCODE:
      return {
        ...state,
        viewPromoCode: {
          ...state.viewPromoCode,
          data: null,
          error: null,
          success: null,
          loading: false,
        },
      };

    // ========================
    // UPDATE PROMOCODE
    // ========================
    case UPDATE_PROMOCODE_REQUEST:
      return {
        ...state,
        updatePromoCode: {
          ...state.updatePromoCode,
          loading: true,
          error: null,
          success: null,
        },
      };

    case UPDATE_PROMOCODE_SUCCESS:
      return {
        ...state,
        updatePromoCode: {
          ...state.updatePromoCode,
          data: payload.data,
          error: null,
          success: payload.message || "Update success",
          loading: false,
        },
      };

    case UPDATE_PROMOCODE_FAILURE:
      return {
        ...state,
updatePromoCode: {
          ...state.updatePromoCode,
          error: payload.message || "Failed to update promo code",
          success: null,
          loading: false,
        },
      };
    case RESET_UPDATE_PROMOCODE:
      return {
        ...state,
        updatePromoCode: {
          ...state.updatePromoCode,
          data: null,
          error: null,
          success: null,
          loading: false,
        },
      };
    // ========================
    // DELETE PROMOCODE
    // ========================
    case DELETE_PROMOCODE_REQUEST:
      return {
        ...state,
        deletePromoCode: {
          ...state.deletePromoCode,
          loading: true,
          error: null,
          success: null,
        },
      };

    case DELETE_PROMOCODE_SUCCESS:
      return {
        ...state,
        deletePromoCode: {
          ...state.deletePromoCode,
          error: null,
          success: payload.message || "Delete success",
          loading: false,
        },
      };

    case DELETE_PROMOCODE_FAILURE:
      return {
        ...state,
        deletePromoCode: {
          ...state.deletePromoCode,
          error: payload.message || "Failed to delete promo code",
          success: null,
          loading: false,
        },
      };
    case RESET_DELETE_PROMOCODE:

      return {
        ...state,
        deletePromoCode: {
          ...state.deletePromoCode,
          data: null,
          error: null,
          success: null,
          loading: false,
        },
      };

      case APPROVAL_PROMOCODE_REQUEST:
      return {
        ...state,
        approvalPromoCode: {
          ...state.approvalPromoCode,
          loading: true,
          error: null,
          success: null,
        },
      };

    case APPROVAL_PROMOCODE_SUCCESS:
      return {
        ...state,
        approvalPromoCode: {
          ...state.approvalPromoCode,
          error: null,
          success: payload.message || "Approval success",
          loading: false,
        },
      };

    case APPROVAL_PROMOCODE_FAILURE:
      return {
        ...state,
        approvalPromoCode: {
          ...state.approvalPromoCode,
          error: payload.message || "Failed to approve promo code",
          success: null,
          loading: false,
        },
      };
    case RESET_APPROVAL_PROMOCODE:
      return {
        ...state,
        approvalPromoCode: {
          ...state.approvalPromoCode,
          data: null,
          error: null,
          success: null,
          loading: false,
        },
      };

      case VALIDATE_PROMOCODE_REQUEST:
      return {
        ...state,
        promoCodeValidation: {
          ...state.promoCodeValidation,
          loading: true,
          error: null,
          success: null,
        },
      };
      case VALIDATE_PROMOCODE_SUCCESS:
      return {
        ...state,
        promoCodeValidation: {
          ...state.promoCodeValidation,
          error: null,
          success: payload || "Validation success",
          loading: false,
        },
      };
      case VALIDATE_PROMOCODE_FAILURE:
      return {
        ...state,
        promoCodeValidation: {
          ...state.promoCodeValidation,
          error: payload.message || "Failed to validate promo code",
          success: null,
          loading: false,
        },
      };
      case RESET_VALIDATE_PROMOCODE:
      return {
        ...state,
        promoCodeValidation: {
          ...state.promoCodeValidation,
          data: null,
          error: null,
          success: null,
          loading: false,
        },
      };




    


    
    // ========================
    // DEFAULT
    // ========================
    default:
      return state;
  }
};

export default promoCodeReducer;
